import { Empty, Button } from "antd";
import Link from "next/link";

const WordingTemplateNotfound = () => {
  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "10px",
        textAlign: "center",
        zIndex: 1000,
        boxShadow:
          "0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
        borderBottomLeftRadius: "2px",
        borderBottomRightRadius: "2px",
      }}
    >
      <Empty description="暂无符合条件的模板" />
      <Link
        target="_blank"
        href="/admin/wording_templates"
      >
        <Button
          type="link"
          size="small"
          style={{
            marginBottom: "10px",
          }}
        >
          创建模板
        </Button>
      </Link>
    </div>
  );
};

export default WordingTemplateNotfound;
